import { useDispatch, useSelector } from "react-redux";
import {
  selectIsEditMode,
  selectCurrentSheet,
  toggleEditMode,
  openBottomSheet,
  closeBottomSheet,
  resetEditMode,
} from "./editModeSlice";

export const useEditMode = () => {
  const dispatch = useDispatch();
  const isEditMode = useSelector(selectIsEditMode);
  const currentSheet = useSelector(selectCurrentSheet);

  return {
    isEditMode,
    currentSheet,
    toggleEditMode: () => {
      dispatch(toggleEditMode());
    },
    openBottomSheet: (sheetType: string) =>
      dispatch(openBottomSheet(sheetType)),
    closeBottomSheet: () => dispatch(closeBottomSheet()),
    resetEditMode: () => dispatch(resetEditMode()),
  };
};
